import { render, staticRenderFns } from "./RightLeader.vue?vue&type=template&id=1c8ccc0c&scoped=true"
import script from "./RightLeader.vue?vue&type=script&lang=js"
export * from "./RightLeader.vue?vue&type=script&lang=js"
import style0 from "./RightLeader.vue?vue&type=style&index=0&id=1c8ccc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8ccc0c",
  null
  
)

export default component.exports